<template>
  <v-container fluid fill-height>
    <v-toolbar color="green darken-1" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <!-- include -->
    <subscribe :packageItem="packageItem"></subscribe>
    <!-- include -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Subscribe from "../_components/subscribe.vue";
export default {
  name: "SubscriptionPage",
  components: {
    Subscribe
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      packageItem: {}
    };
  },
  created() {
    this.$store
      .dispatch("get", "/packages/" + this.$route.params.id)
      .then(res => {
        this.packageItem = res.packageItem;
      });
  }
};
</script>



